const roleNames = {
  admin: 'Administrator',
  doorman: 'Doorman',
  analyst: 'Analyst',
  contractor: 'Contractor',
  superadmin: 'Super Administrator'
}

export default roleNames;
